@if (form$ | async; as form) {
  <form
    [formGroup]="form"
    (ngSubmit)="submit(form)">
    @if (entries$ | async; as entries) {
      <app-efa-cancel-or-return-items
        [entries]="entries"
        [isConfirmation]="true">
      </app-efa-cancel-or-return-items>
    }
    <ng-container *ngTemplateOutlet="actions"></ng-container>
    <ng-template #actions>
      @if (orderCode) {
        <app-efa-amend-order-actions
          class="row justify-content-end"
          [orderCode]="orderCode"
          [amendOrderForm]="form"
        backRoute="orderCancel"></app-efa-amend-order-actions>
      }
    </ng-template>
  </form>
}
